import { useMemo } from 'react'
import { HandledDeliveryFee } from 'types/storeDeliveryFee'

type UseValidateDeliveryFees = { caution: string; id: string }[]

const useValidateDeliveryFees = (deliveryFees: HandledDeliveryFee[]): UseValidateDeliveryFees => {
  return useMemo(() => {
    const errors: { caution: string; id: string }[] = []
    if (deliveryFees.every((deliveryFee) => deliveryFee.region_type !== 'any')) {
      errors.push({
        caution: '地域の設定に誤りがあります。地域には「その他地域一律」を必ず含めてください。',
        id: 'delivery-fee-individual',
      })
    }
    if (deliveryFees.some((deliveryFee) => deliveryFee.sizes.length === 0)) {
      errors.push({
        caution: '箱のサイズが指定されていません。箱のサイズを1つ以上指定してください。',
        id: 'delivery-fee-bulk',
      })
    }
    return errors
  }, [deliveryFees])
}

export default useValidateDeliveryFees
